import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import Header from '../_components/Header';
import backIcon from '../_assets/imgs/back.png';
import { jobsActions } from '../_actions';
import Spinner from '../_components/Spinner';
import calendarIcon from '../_assets/new/detail/calendar_today.png';
import Place from '../_assets/new/detail/place.png';
import Person from '../_assets/new/detail/person.png';
import Time from '../_assets/new/detail/time.png';
import cardTravel from '../_assets/new/detail/card_travel.png';
import driveEta from '../_assets/new/detail/drive_eta.png';
import workOutlin from '../_assets/new/detail/work_outline.png';

function DetailVacancy() {
  const dispatch = useDispatch();
  const { key } = useParams();
  const location = useLocation();
  const detailJob = useSelector((state) => state.jobsForm.detailJob);

  useEffect(() => {
    dispatch(jobsActions.detailVacancyAction(key));
  }, [dispatch, key]);

  function getBack() {
    const searchParams = new URLSearchParams(location.search);
    const backPath = searchParams.get('back');

    return backPath ? '/' + backPath : '/vacancies';
  }

  return (
    <div className="detail-jobs">
      <Header />

      <div className="container">
        <div className="row">
          <div className="col-md-5">
            <div className="text-right">
              <Link to={getBack()}>
                <span className="back">
                  <img src={backIcon} alt="" />
                  Regresar al inicio
                </span>
              </Link>
            </div>
          </div>
          <div className="col-md-7">
            {detailJob ? setDetail(detailJob) : <Spinner />}
          </div>
        </div>
      </div>
    </div>
  );
}

function setDetail(detailJob) {
  return (
    <div className="job-detail">
      <img className="principal" src={detailJob.business_info?.logo} />
      <h2 className="marginless title">{detailJob.name}</h2>
      <div className="btns-edit-remove">
        <span className="text">
          {' '}
          {detailJob.business_info?.business_name} -{' '}
          {detailJob.business_info?.activity}
        </span>

        <span
          className={'tag float-right ' + (detailJob.is_active ? 'active' : '')}
        >
          {detailJob.is_active ? 'Activo' : 'Inactivo'}
        </span>
      </div>
      <div className="salary">${detailJob.salary}</div>
      <div className="row job-important">
        <div className="col-md-6">
          <div className="text">
            <img src={calendarIcon} /> {detailJob.job_type || '-'}
          </div>
          <div className="text">
            <img src={Place} />
            {detailJob.location}
          </div>
          <div className="text">
            <img src={Person} />
            Vacante incluyente: {detailJob.disability ? 'SI' : 'NO'}
          </div>
          <div className="text">
            <img src={Time} /> De {detailJob.check_in} a {detailJob.check_out}
          </div>
          <div className="text">
            <img src={calendarIcon} /> {detailJob.work_days_string}{' '}
          </div>
        </div>
        <div className="col-md-6">
          <div className="text">
            <img src={Person} />
            Género: {detailJob.requirements?.genere || '-'}
          </div>
          <div className="text">
            <img src={workOutlin} />
            {detailJob.experience}
          </div>
          <div className="text">
            <img src={Person} />{' '}
            {detailJob.requirements?.age_range
              ? `De ${detailJob.requirements?.age_range} años`
              : 'n/a'}
          </div>
          <div className="text">
            <img src={cardTravel} />
            Disponibilidad para viajar:{' '}
            {detailJob.requirements?.availability_to_travel ? 'si' : 'no'}
          </div>
          <div className="text">
            <img src={driveEta} />
            Disponibilidad para radicar fuera:{' '}
            {detailJob.requirements?.availability_to_move ? 'si' : 'no'}
          </div>
        </div>
      </div>

      <h3 className="subtitle">REQUERIMIENTOS</h3>
      <div className="text">
        <ul>
          <li>
            Grado de estudios requerido:{' '}
            {detailJob.requirements?.academic_situation || '-'}{' '}
          </li>
          <li>
            Especifique carrera o especialidad:{' '}
            {detailJob.requirements?.degree || '-'}{' '}
          </li>
        </ul>
      </div>
      <h3 className="subtitle">FUNCIONES Y ACTIVIDADES A REALIZAR</h3>
      <div className="text">{detailJob.description || '-'}</div>
      <h3 className="subtitle">CONOCIMIENTOS Y HABILIDADES REQUERIDOS</h3>
      <div className="text">{detailJob.knowledge || '-'}</div>
      <h3 className="subtitle">PRESTACIONES</h3>
      <div className="text">{detailJob.benefits || '-'}</div>
    </div>
  );
}

export { DetailVacancy };
